import { TextInput } from '@carbon/react';
import { useCategoryFields } from '../template-hooks';
import type { FilterTemplateProps } from '../../types';
import style from '../filter-modal.module.scss';

export const TextTemplate = ({
  category,
  formValues,
  onFormChange,
}: FilterTemplateProps) => {
  const fields = useCategoryFields(category, 'text');

  return (
    <div className={style.fieldStack}>
      {fields.map((field) => (
        <TextInput
          key={field.id}
          id={`filter-${field.id}`}
          labelText={field.label}
          placeholder={
            field.placeholder ?? `Search by ${field.label.toLowerCase()}...`
          }
          value={(formValues[field.param] as string) ?? ''}
          onChange={(e) =>
            onFormChange(field.param, e.target.value || undefined)
          }
          size="md"
        />
      ))}
    </div>
  );
};
